import { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name ProLayoutProps 配置
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  // navTheme: light | realDark
  // 需同步修改app.ts、@/components/CustomLayout/Header/RightContent/ThemeSwitch.ts中的navTheme
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  // colorPrimary: 'hsl(245 82% 67%)',
  // 导航模式: side-侧边菜单布局 | top-顶部菜单布局 | mix-混合菜单布局
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  // siderMenuType: 'group',
  colorWeak: false,
  pwa: true,
  // logo: 'https://p1.meituan.net/erpportal/2b8f21f3d2417816c06e8f64a855a7c65979.png',
  iconfontUrl: '',
  // token: {
  //   // 参见ts声明，demo 见文档，通过token 修改样式
  //   //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  // },
  token: {
    // header: {
    //   colorBgHeader: '#292f33',
    //   // colorBgHeader: 'rgba(0,0,0,0.65)',
    //   colorHeaderTitle: '#fff',
    //   colorTextMenu: '#dfdfdf',
    //   colorTextMenuSecondary: '#dfdfdf',
    //   colorTextMenuSelected: '#fff',
    //   colorBgMenuItemSelected: '#22272b',
    //   colorTextRightActionsItem: '#dfdfdf',
    // },
    sider: {
      colorMenuItemDivider: '#dfdfdf',
      colorTextMenu: '#595959',
      colorTextMenuSelected: 'rgba(42,122,251,1)',
      colorBgMenuItemSelected: 'rgba(230,243,254,1)',

      colorBgCollapsedButton: '#fff',
      colorTextCollapsedButtonHover: 'rgba(0,0,0,0.65)',
      colorTextCollapsedButton: 'rgba(0,0,0,0.45)',
      colorBgMenuItemCollapsedElevated: 'rgba(0,0,0,0.85)',
      // colorMenuItemDivider: 'rgba(255,255,255,0.15)',
      colorBgMenuItemHover: 'rgba(0,0,0,0.06)',
      // colorBgMenuItemSelected: 'rgba(0,0,0,0.15)',
      // colorTextMenuSelected: '#fff',
      // colorTextMenuItemHover: 'rgba(255,255,255,0.75)',
      // colorTextMenuItemHover: 'rgba(42,122,251,1)',
      // colorTextMenu: 'rgba(255,255,255,0.75)',
      colorTextMenuSecondary: 'rgba(255,255,255,0.65)',
      colorTextMenuTitle: 'rgba(255,255,255,0.95)',
      colorTextMenuActive: 'rgba(255,255,255,0.95)',
      colorTextSubMenuSelected: '#fff',
    },
  },
};

export default Settings;
